import React from 'react';
import LeaderboardWidgetFavoriteCellTitle from './leaderboard-widget-favorite-cell-title';

const LeaderboardWidgetFavoriteRowTitle = ({ numberOfCells }) => {
    return (
        <div className="leaderboard-widget-favorite__row is-title">
            {
                numberOfCells.map((item) => {
                    return <LeaderboardWidgetFavoriteCellTitle
                        key={item.id}
                        state={item}
                    />;
                })
            }
        </div>
    );
};

export default LeaderboardWidgetFavoriteRowTitle;
